import { Stop_Times } from "../../parsegenerated";

export class StopTimeModel {
  trip_id?: string;
  stop_id?: string;
  arrival_time?: string;
  departure_time?: string;
  stop_sequence?: number;
}

export function toStopTimeModel(data: Stop_Times): StopTimeModel {
  return {
    trip_id: data.trip_id.id,
    stop_id: data.stop_id.get("stop_id"),
    arrival_time: data.arrival_time?.getTime().toString(),
    departure_time: data.departure_time?.getTime().toString(),
    stop_sequence: data.stop_sequence,
  };
}
